import { ContractApiService } from "./ContractApiService";
import { RestApiClient } from "../../../Scripts/inpulse/RestApiClient";
import { IContractProcessModel } from "../../../Scripts/vue-components/mycontracts/ContractApiService";

declare interface Window {
    location: Location;
}

declare interface Location {
    origin: string;
}


/*Service to handle feedback related stuff*/
export class DefaultContractService {

    private _service: ContractApiService;
    private _followUpCount = 0;
    private _followUpCountPlaceHolder: HTMLElement;
    private _followUpOffers: IContractProcessModel[];

    constructor(apiUrl: string, followUpContractCountPlaceHolder: HTMLElement) {
        if (apiUrl == null) {
            apiUrl = window.location.origin + "api/feedback";
        }
        this._service = new ContractApiService(new RestApiClient(apiUrl), apiUrl);
        this._followUpCountPlaceHolder = followUpContractCountPlaceHolder;
    }

    GetFollowUpOffers(): IContractProcessModel[] {
        return this._followUpOffers;
    }

    ShowFollowUpProcessesCount(fuContracts: IContractProcessModel[]): void {
        this._service.getFollowUpOffers().then(result => {
            if (result !== null) {
                //TODO logic to add messages count to post
                console.log(result);
                this._followUpCount = result.length;
                this._followUpOffers = result;
            }
            else {
                this._followUpCount = 0;
            }
        }).catch(error => {
            console.error(error);
        }).finally(() => {
            this.showfollowUpCount(this._followUpCount);
        });
    }

    private showfollowUpCount(count: number) {
        if (count > 0) {
            this._followUpCountPlaceHolder.innerText = count.toString();
            this._followUpCountPlaceHolder.classList.add("active");
        }
        else {
            this._followUpCountPlaceHolder.classList.remove("active");
        }
    }

}